export enum BlogsWorkspaceCapabilityAccessOperation {
    create = "0cd4ca10-8cda-4ab0-9573-042d6ecaa355",
    read = "d5f9564c-655e-4d97-9d11-e88e8d29b2b3",
    update = "8e0e4b4f-c049-491c-aed0-621d03f33e06",
    delete = "40a8cd23-2db9-4582-9a49-fd63e88fac79",
}
